import React, { useContext } from 'react';

// import data
import { MernProjects, ReactProjects, projectsData } from '../data';

// import components
import Project from './Project';
import { SimpleGrid, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { ThemeContext } from '../context/ThemeContext';
import SingleProject from './SingleProject';
import { memo } from 'react';


const Projects = () => {

  const { Theme } = useContext(ThemeContext)
  return (
    <div>

      <Tabs variant='unstyled' align='center' >
        {/* All Tabs Navigation */}
        <TabList mb="5" >
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` ,border:"0px"}} borderRadius={"7px"} bg={Theme === "dark" ? "#61605e" : "#fff"}  color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "7", "10"]} className='boxShadow' _hover={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "#F08E8B"}` }} >All</Tab>
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` ,border:"0px"}} borderRadius={"7px"} bg={Theme === "dark" ? "#61605e" : "#fff"}  color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "7", "10"]} className='boxShadow' _hover={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "#F08E8B"}` }}>React</Tab>
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` ,border:"0px"}} borderRadius={"7px"} bg={Theme === "dark" ? "#61605e" : "#fff"}  color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "7", "10"]} className='boxShadow' _hover={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "#F08E8B"}` }}>MERN</Tab>
        </TabList>
        <TabPanels>
          {/* All Projects */}
          <TabPanel>
            <SimpleGrid columns={[2, 2, 2, 3, 4]} spacing={[2, 2, 3, 5, 6]} w={["100%", "100%", "95%", "95%", "95%"]} m='auto' >

              {projectsData.map((item) => {
                return <SingleProject data={item} key={item.id} />;
              })}
            </SimpleGrid>
          </TabPanel>
          <TabPanel>
            <SimpleGrid columns={[2, 2, 2, 3, 4]} spacing={[2, 2, 3, 5, 6]} w={["100%", "100%", "95%", "95%", "95%"]} m='auto' >

              {ReactProjects.map((item) => {
                return <SingleProject data={item} key={item.id} />;
              })}
            </SimpleGrid>
          </TabPanel>
          <TabPanel>
            <SimpleGrid columns={[2, 2, 2, 3, 4]} spacing={[2, 2, 3, 5, 6]} w={["100%", "100%", "95%", "95%", "95%"]} m='auto' >

              {MernProjects.map((item) => {
                return <SingleProject data={item} key={item.id} />;
              })}
            </SimpleGrid>
          </TabPanel>
        </TabPanels>
      </Tabs>


    </div>
  );
};




export default memo(Projects);
